import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "../../../RoutersCst";
import DashboardCorporateAssociation from "@pages/Contents/Dashboard/CorporateAssociation";
import EditDashboard from "@pages/Contents/Dashboard/CorporateAssociation/EditDashboard";
import CorporateAssociationDashboard from "@pages/Contents/Dashboard/CorporateAssociation/CorporateAssociationDashboard";

const useDashboardAssociateCorporate = () => {
  const { isInclude } = useIsInclude();

  return {
    path: "corporate-association",
    children: [
      {
        index: true,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("smartconfigurator.quicksight.read")}
          >
            <DashboardCorporateAssociation />
          </ProtectedRoute>
        ),
      },
      {
        index: false,
        path: "edit/:dashboardId",
        element: (
          <ProtectedRoute
            isAllowed={isInclude("smartconfigurator.quicksight.read")}
          >
            <EditDashboard />
          </ProtectedRoute>
        ),
      },
      {
        index: false,
        path: ":dashboardId/corporate-association",
        element: (
          <ProtectedRoute
            isAllowed={isInclude(
              "smartconfigurator.quicksight.associate.corporates",
            )}
          >
            <CorporateAssociationDashboard />
          </ProtectedRoute>
        ),
      },
    ],
  };
};
export default useDashboardAssociateCorporate;
